import React from "react";
import CountUp from "react-countup";
import "./AboutAndVissionMission.css";
import { FaRocket, FaEye, FaStar } from "react-icons/fa";
import aboutIimg1 from "../../assets/images/about-1.jpg";
import aboutIimg2 from "../../assets/images/about-2.jpg";

const AboutAndVissionMission = () => {
  return (
    <section className="aboutVissionMission-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Text Section */}
          <div className="col-lg-6 col-md-12 col-sm-12 about-text">
            <h2>
              Empowering Minds,{" "}
              <span className="highlight">Shaping Futures</span>
            </h2>
            <p>
              Vasavi College of Engineering stands as a distinguished Private
              Un-aided Non-minority Autonomous Institution, proudly Accredited
              by NAAC with an 'A++' Grade. Established under the esteemed Vasavi
              Academy of Education and Affiliated to Osmania University,
              Hyderabad, the college holds the Approval of AICTE, New Delhi,
              signifying its commitment to quality technical education.
            </p>
            <p>
              Founded in 1981, Vasavi College of Engineering represents a rich
              tradition of excellence in technology-based education. In its 44
              years of existence, it has become a reputed institution in
              Telangana.
            </p>

            {/* Stats Section */}
            <div className="stats">
              <div className="stat-box">
                <h3>
                  <CountUp start={0} end={44} duration={3} suffix="+" />
                </h3>
                <p>Years</p>
              </div>
              <div className="stat-box">
                <h3>
                  <CountUp start={0} end={2500} duration={3} suffix="+" />
                </h3>
                <p>Students</p>
              </div>
              <div className="stat-box">
                <h3>
                  <CountUp start={0} end={125} duration={3} suffix="+" />
                </h3>
                <p>Faculty</p>
              </div>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="col-lg-6 col-md-12 col-sm-12 about-images">
            <div className="image-wrapper">
              <img src={aboutIimg1} alt="Students" className="img1 img-fluid" />
              <img src={aboutIimg2} alt="Event" className="img2 img-fluid" />
            </div>
          </div>
        </div>

        {/* Mission / Vision / Values Section */}
        <div className="row mission-vision-values">
          <div className="col-lg-4 col-md-6 col-sm-12 ">
            <div className="mvv-box">
              <FaRocket className="icon" />
              <h4>Our Mission</h4>
              <p>
                To arm young brains with competitive technology and nurture
                holistic development of the individuals for a better tomorrow
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 ">
            <div className="mvv-box">
              <FaEye className="icon" />
              <h4>Our Vision</h4>
              <p>
                Striving for a symbiosis of technological excellence and human
                values
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 ">
            <div className="mvv-box">
              <FaStar className="icon" />
              <h4>Our Values</h4>
              <p>
                Education without quality is like a flower without fragrance. It
                is our earnest resolve to strive towards imparting high
                standards of teaching, training and developing human resources.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAndVissionMission;
